import React from 'react';
import { XCircleIcon, ClockIcon, AlertTriangleIcon } from 'lucide-react';
export function ProblemSection() {
  const failedAttempts = ['Seguiste menús con ingredientes que no se consiguen en la tienda de la esquina.', 'Intentaste comer solo lechuga y atún, matándote de hambre y ansiedad.', 'Pensaste que "comer sano" era un lujo reservado para los que tienen presupuesto ilimitado.', 'Te sentiste perdido en la calle sin saber qué pedir en un piqueteadero o restaurante.', 'No tuviste un sistema de emergencia para cuando el hambre aprieta a las 4 de la tarde.'];
  return <section className="bg-[#FAFAF5] text-[#1A1A1A] py-16 md:py-24 px-4" data-id="element-116">
      <div className="max-w-4xl mx-auto" data-id="element-117">
        {/* Opening Hook */}
        <div className="mb-16 bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-gray-100 relative" data-id="element-118">
          <div className="absolute -top-6 left-8 bg-[#F5C518] text-[#1A1A1A] p-3 rounded-xl shadow-lg transform -rotate-3" data-id="element-119">
            <ClockIcon className="w-8 h-8" data-id="element-120" />
          </div>
          <p className="font-inter text-xl md:text-2xl leading-relaxed font-medium text-gray-800 mt-4" data-id="element-121">
            Son las 12:15 p.m. Tienes hambre, estás en la oficina o en la calle
            y la única opción parece ser el "corrientazo" lleno de arroz, papa y
            plátano que te deja inflamado y con sueño toda la tarde.
          </p>
          <p className="font-inter text-lg md:text-xl leading-relaxed text-gray-600 mt-6" data-id="element-122">
            Sabes que tienes que bajar de peso, pero crees que la dieta Keto es
            solo para gente con plata que compra salmón, harina de almendras de
            50 mil pesos y aceite de coco importado.
          </p>
        </div>

        {/* The Problem */}
        <div className="mb-16" data-id="element-123">
          <h3 className="font-montserrat font-bold text-3xl md:text-4xl mb-6 text-[#1A1A1A]" data-id="element-124">
            La mayoría de los colombianos fallan en la dieta Keto porque
            intentan seguir planes diseñados para gente en Estados Unidos o
            Europa.
          </h3>
          <p className="font-inter text-lg text-gray-700 leading-relaxed" data-id="element-125">
            Se frustran buscando ingredientes raros, gastan una fortuna en la
            zona "fit" del supermercado y terminan rindiéndose a los tres días
            porque extrañan el sabor de nuestra comida o porque simplemente no
            tienen tiempo de cocinar recetas de 40 pasos. No es falta de
            voluntad, es falta de un plan adaptado a nuestra realidad, a
            nuestros precios y a nuestro sazón.
          </p>
        </div>

        {/* What You Tried */}
        <div className="bg-red-50 rounded-2xl p-8 md:p-10 border border-red-100" data-id="element-126">
          <div className="flex items-center gap-3 mb-8" data-id="element-127">
            <AlertTriangleIcon className="w-8 h-8 text-[#EF4444]" data-id="element-128" />
            <h3 className="font-montserrat font-bold text-2xl md:text-3xl text-[#1A1A1A]" data-id="element-129">
              Por qué lo que intentaste NO funcionó:
            </h3>
          </div>
          <ul className="space-y-4" data-id="element-130">
            {failedAttempts.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-131">
                <XCircleIcon className="w-6 h-6 text-[#EF4444] flex-shrink-0 mt-1" data-id="element-132" />
                <span className="font-inter text-lg text-gray-800" data-id="element-133">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}